module.exports = __webpack_public_path__ + "912ec66d7572ff821749319396470bde.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-css/themes/default/assets/fonts/icons.svg
// module id = 1006
// module chunks = 0